/**
 * Positions of Annotations are defined in Annotations.scss
 */
export default[

    {
        type : "annotation",
        position : "center-top",
        time : 83,
        showTime : 3,
        title : "Watch tower"
    }, {
        type : "annotation",
        position : "center-center",
        time : 117,
        showTime : 3,
        title : "Checkpoint"
    }, {
        type : "annotation",
        position : "center-center",
        time : 146,
        showTime : 4,
        title : "Meitar checkpoint, entrance to the West Bank"
    }, {
        type : "annotation",
        position : "center-right",
        time : 163,
        showTime : 3,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-left",
        time : 171,
        showTime : 4,
        title : "Entrance to the West Bank / Area C"
    }, {
        type : "annotation",
        position : "center-right",
        time : 177,
        showTime : 3,
        title : "Separation wall"
    }, {
        type : "annotation",
        position : "center-right",
        time : 188,
        showTime : 3,
        title : "Green Line"
    }, {
        type : "annotation",
        position : "center-right",
        time : 211,
        showTime : 4,
        title : "Military road along the separation wall"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 224,
        showTime : 2,
        title : "Exit to Carmel settlement"
    }, {
        type : "annotation",
        position : "center-center",
        time : 235,
        showTime : 3,
        title : "Military distance markers on both sides of the road"
    }, {
        type : "annotation",
        position : "center-right",
        time : 252,
        showTime : 4,
        title : "Shim'a settlement"
    }, {
        type : "annotation",
        position : "top-right",
        time : 266,
        showTime : 16,
        title : "Mitzpe Eshtamoa outpost"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 294,
        showTime : 12,
        title : "Earthmound"
    }, {
        type : "annotation",
        position : "top-left",
        time : 380,
        showTime : 18,
        title : "Otniel settlement"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 404,
        showTime : 2,
        title : "Settler with weapon"
    }, {
        type : "annotation",
        position : "center-top",
        time : 409,
        showTime : 3,
        title : "Military presence at the entrance to Area A"
    }, {
        type : "annotation",
        position : "center-right",
        time : 418,
        showTime : 10,
        title : "Roadblock, entrance to Area A"
    }, {
        type : "annotation",
        position : "center-left",
        time : 434,
        showTime : 10,
        title : "Military Base"
    }, {
        type : "annotation",
        position : "center-right",
        time : 459,
        showTime : 5,
        title : "Entrance to Area A, at the Palestinian village Al Hijra"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 469,
        showTime : 3,
        title : "Earthmound"
    }, {
        type : "annotation",
        position : "center-center",
        time : 483,
        showTime : 3,
        title : "Al Fawwar checkpoint"
    }, {
        type : "annotation",
        position : "center-right",
        time : 487,
        showTime : 3,
        title : "Rumble strips against speed and explosives"
    }, {
        type : "annotation",
        position : "center-right",
        time : 493,
        showTime : 2,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-right",
        time : 501,
        showTime : 5,
        title : "Al Fawwar refugee camp"
    }, {
        type : "annotation",
        position : "center-top",
        time : 509,
        showTime : 2,
        title : "Entrance to area A"
    }, {
        type : "annotation",
        position : "center-center",
        time : 513,
        showTime : 2,
        title : "Military control at a partial checkpoint"
    }, {
        type : "annotation",
        position : "center-top",
        time : 518,
        showTime : 6,
        title : "Al Fawwar refugee camp"
    }, {
        type : "annotation",
        position : "bottom-left",
        time : 535,
        showTime : 2,
        title : "Army jeep"
    }, {
        type : "annotation",
        position : "bottom-left",
        time : 539,
        showTime : 4,
        title : "Straight ahead former route 60 enters Hebron"
    }, {
        type : "annotation",
        position : "center-top",
        time : 546,
        showTime : 3,
        title : "Haggai settlement"
    }, {
        type : "annotation",
        position : "center-center",
        time : 551,
        showTime : 2,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-left",
        time : 554,
        showTime : 2,
        title : "Israeli police"
    }, {
        type : "annotation",
        position : "center-left",
        time : 573,
        showTime : 3,
        title : "Entrance to area A with a roadblock"
    }, {
        type : "annotation",
        position : "top-left",
        time : 579,
        showTime : 4,
        title : "Military base"
    }, {
        type : "annotation",
        position : "center-left",
        time : 585,
        showTime : 2,
        title : "Hebron"
    }, {
        type : "annotation",
        position : "center-right",
        time : 589,
        showTime : 3,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 596,
        showTime : 2,
        title : "Entrance to area A with a checkpoint"
    }, {
        type : "annotation",
        position : "center-left",
        time : 602,
        showTime : 4,
        title : "Military base"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 609,
        showTime : 3,
        title : "Exit to the Cave of the Patriarchs"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 613,
        showTime : 3,
        title : "Entrance to Area A, open road gate"
    }, {
        type : "annotation",
        position : "center-left",
        time : 632,
        showTime : 5,
        title : "Exit to Kiryat Arba settlement"
    }, {
        type : "annotation",
        position : "top-left",
        time : 638,
        showTime : 20,
        title : "Kiryat Arba settlement"
    }, {
        type : "annotation",
        position : "center-right",
        time : 669,
        showTime : 3,
        title : "Army jeep"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 675,
        showTime : 3,
        title : "Exit to the Palestinian villages Sa’ir and Beit Einun"
    }, {
        type : "annotation",
        position : "center-center",
        time : 680,
        showTime : 5,
        title : "Ras al Joura checkpoint"
    }, {
        type : "annotation",
        position : "center-right",
        time : 686,
        showTime : 2,
        title : "Entrance to Area A"
    }, {
        type : "annotation",
        position : "center-left",
        time : 692,
        showTime : 3,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-left",
        time : 699,
        showTime : 4,
        title : "Fence to prevent stone throwers"
    }, {
        type : "annotation",
        position : "center-right",
        time : 714,
        showTime : 3,
        title : "Open road gate to Al Arrub refugee camp"
    }, {
        type : "annotation",
        position : "center-right",
        time : 720,
        showTime : 3,
        title : "Israeli armored cars with observation tower"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 725,
        showTime : 3,
        title : "Light armored cars with soldiers"
    }, {
        type : "annotation",
        position : "center-left",
        time : 759,
        showTime : 4,
        title : "Rami Levy supermarket"
    }, {
        type : "annotation",
        position : "center-center",
        time : 797,
        showTime : 4,
        title : "Gush Etzion checkpoint"
    }, {
        type : "annotation",
        position : "center-left",
        time : 803,
        showTime : 5,
        title : "Secured bus stop"
    }, {
        type : "annotation",
        position : "center-right",
        time : 822,
        showTime : 3,
        title : "Soldiers are checking a Palestinian car"
    }, {
        type : "annotation",
        position : "center-top",
        time : 826,
        showTime : 2,
        title : "Military tower"
    }, {
        type : "annotation",
        position : "center-left",
        time : 831,
        showTime : 2,
        title : "Soldiers"
    }, {
        type : "annotation",
        position : "center-right",
        time : 837,
        showTime : 4,
        title : "Efrat settlement"
    }, {
        type : "annotation",
        position : "top-right",
        time : 848,
        showTime : 4,
        title : "Bethlehem"
    }, {
        type : "annotation",
        position : "center-right",
        time : 854,
        showTime : 4,
        title : "Exit to the former route 60 through Bethlehem"
    }, {
        type : "annotation",
        position : "center-right",
        time : 867,
        showTime : 3,
        title : "Open roadblock to the entrance of Area A"
    }, {
        type : "annotation",
        position : "center-right",
        time : 872,
        showTime : 3,
        title : "Former route 60 through Bethlehem"
    }, {
        type : "annotation",
        position : "center-left",
        time : 880,
        showTime : 6,
        title : "Separation wall"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 890,
        showTime : 4,
        title : "Behind the wall, the Palestinian villages Al Khadr en Bethlehem"
    }, {
        type : "annotation",
        position : "top-right",
        time : 896,
        showTime : 2,
        title : "Roadblock"
    }, {
        type : "annotation",
        position : "top-right",
        time : 902,
        showTime : 3,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-right",
        time : 910,
        showTime : 2,
        title : "Military armored car"
    }, {
        type : "annotation",
        position : "center-right",
        time : 916,
        showTime : 3,
        title : "Separation wall"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 922,
        showTime : 3,
        title : "Soldiers"
    }, {
        type : "annotation",
        position : "top-left",
        time : 928,
        showTime : 3,
        title : "Tunnel checkpoint"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 931,
        showTime : 2,
        title : "Rumble strips against speed and explosives"
    }, {
        type : "annotation",
        position : "center-top",
        time : 937,
        showTime : 6,
        title : "From here on, cars with Palestinian plates are not allowed to continue on route 60"
    }, {
        type : "annotation",
        position : "center-top",
        time : 976,
        showTime : 5,
        title : "Tunnels underneath the Palestinian village Beit Jala"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 982,
        showTime : 2,
        title : "Separation wall on both sides of the road"
    }, {
        type : "annotation",
        position : "top-left",
        time : 987,
        showTime : 2,
        title : "Gilo settlement"
    }, {
        type : "annotation",
        position : "center-left",
        time : 991,
        showTime : 2,
        title : "Jerusalem"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1012,
        showTime : 4,
        title : "This is again the former route 60 towards Bethlehem"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1030,
        showTime : 4,
        title : "Separation wall with Bethlehem behind it"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1038,
        showTime : 3,
        title : "Entrance to Rachel's tomb"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1051,
        showTime : 5,
        title : "Beginning of the municipal border of Jerusalem, according to Israel"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1138,
        showTime : 3,
        title : "Green Line"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1158,
        showTime : 4,
        title : "the Church of the Dormition, the place where Mary died"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1165,
        showTime : 5,
        title : "Behind this mountain you find the Wailing Wall and the Al Aqsa Mosque"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1176,
        showTime : 4,
        title : "The wall around the Old City, built by the Ottomans"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1182,
        showTime : 3,
        title : "Tower of David"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1208,
        showTime : 5,
        title : "The Dome of the Rock"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1223,
        showTime : 12,
        title : "Damascus Gate"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1254,
        showTime : 6,
        title : "The Green Line"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1277,
        showTime : 2,
        title : "The Green Line"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1280,
        showTime : 2,
        title : "East-Jerusalem"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1283,
        showTime : 2,
        title : "West-Jerusalem"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1315,
        showTime : 4,
        title : "The Jewish neighborhood French Hill"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1325,
        showTime : 2,
        title : "Shuafat refugee camp"
    }, {
        type : "annotation",
        position : "top-left",
        time : 1333,
        showTime : 3,
        title : "The Palestinian neighborhood Beit Hanina"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1348,
        showTime : 5,
        title : "Settler bus"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1376,
        showTime : 2,
        title : "Pisgat Ze'ev settlement"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1381,
        showTime : 5,
        title : "Al Ram"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1392,
        showTime : 6,
        title : "The Separation wall with the Palestinian village Al Ram behind it"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1423,
        showTime : 4,
        title : "Qalandia checkpoint"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1431,
        showTime : 4,
        title : "Route 60 enters Area A"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1438,
        showTime : 6,
        title : "It is forbidden for Israeli citizens to enter"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1469,
        showTime : 4,
        title : "Cars and people on the way to Jerusalem are checked"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1479,
        showTime : 3,
        title : "Separation wall"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1511,
        showTime : 3,
        title : "Al Ram"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1516,
        showTime : 6,
        title : "Warning from route planner Waze for 'dangerous' area"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1535,
        showTime : 3,
        title : "Al Ram"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1604,
        showTime : 3,
        title : "Jaba checkpoint"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1608,
        showTime : 2,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1612,
        showTime : 4,
        title : "Rumble strips against speed and explosives"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1620,
        showTime : 4,
        title : "Psagot settlement"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1633,
        showTime : 5,
        title : "The Palestinian village Burqa"
    }, {
        type : "annotation",
        position : "top-left",
        time : 1650,
        showTime : 2,
        title : "Burqa"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1680,
        showTime : 3,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1693,
        showTime : 5,
        title : "Ofra settlement"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1698,
        showTime : 5,
        title : "Amona outpost"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1706,
        showTime : 3,
        title : "Fence around Ofra settlement"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1725,
        showTime : 5,
        title : "Entrance to Ofra settlement"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1736,
        showTime : 3,
        title : "Secured bus stop with soldiers guarding"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1741,
        showTime : 2,
        title : "Observation tower"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1747,
        showTime : 4,
        title : "Military base"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1757,
        showTime : 4,
        title : "Shilo settlement"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1761,
        showTime : 4,
        title : "Shilo settlement"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1775,
        showTime : 3,
        title : "A settler bus followed by a Palestinian taxi bus"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1786,
        showTime : 4,
        title : "Observation balloon with camera"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1792,
        showTime : 2,
        title : "Rechelim South settlement"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1796,
        showTime : 3,
        title : "Tappuah checkpoint"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1803,
        showTime : 3,
        title : "Military tower"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1811,
        showTime : 2,
        title : "Military tower"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1818,
        showTime : 2,
        title : "Guarding soldiers at a bus stop"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1825,
        showTime : 4,
        title : "The Palestinian village Huwwara"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1832,
        showTime : 2,
        title : "Roundabout sponsored by USAID"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1853,
        showTime : 2,
        title : "Yitzhar settlement"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1856,
        showTime : 6,
        title : "Military base"
    }, {
        type : "annotation",
        position : "bottom-left",
        time : 1889,
        showTime : 2,
        title : "Military distance markers"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1897,
        showTime : 3,
        title : "Military watchtower"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1907,
        showTime : 3,
        title : "Sarra-Jit checkpoint, entrance to Area A"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1912,
        showTime : 2,
        title : "Military watchtower"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1916,
        showTime : 2,
        title : "Military patrol"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1919,
        showTime : 1,
        title : "Military armored vehicle"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1929,
        showTime : 4,
        title : "Route 60 continues in area A"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1935,
        showTime : 4,
        title : "Entry forbidden for Israeli citizens"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1943,
        showTime : 3,
        title : "The Palestinian village Deir Sharaf"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1954,
        showTime : 3,
        title : "Shavei Shomron settlement"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1958,
        showTime : 3,
        title : "Wall around Shavei Shomron settlement"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1963,
        showTime : 2,
        title : "Shavei Shomron checkpoint"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1968,
        showTime : 1,
        title : "Military jeep"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1980,
        showTime : 10,
        title : "The Palestinian city Jenin"
    }, {
        type : "annotation",
        position : "center-right",
        time : 2018,
        showTime : 4,
        title : "Palestinian officer"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 2033,
        showTime : 5,
        title : "Palestinian security forces"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 2046,
        showTime : 2,
        title : "Palestinian police"
    }, {
        type : "annotation",
        position : "center-center",
        time : 2084,
        showTime : 4,
        title : "On the way to the border with Israel"
    }, {
        type : "annotation",
        position : "center-center",
        time : 2117,
        showTime : 6,
        title : "Al Jalama checkpoint"
    }, {
        type : "annotation",
        position : "center-center",
        time : 2130,
        showTime : 12,
        title : "The border with Israel on the Green Line"
    }
]



// WEBPACK FOOTER //
// ./src/data/timeline-annotations.js